import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ChartConfig {
  id: number;
  name: string;
  description: string | null;
  type: string;
  filters: any;
  configs: string;
}

interface ApiResponse<T> {
  data: T;
  message: string;
  customValues: any;
}

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  private readonly chartsBaseUrl = environment.main_url + '/agilelegal/charts';

  constructor(private http: HttpClient) {}

  /**
   * Get charts that are already mapped to the current user
   * Endpoint: GET /agilelegal/charts/getUserCharts
   * Uses the currently logged-in user from the session
   */
  getUserCharts(): Observable<ApiResponse<ChartConfig[]>> {
    return this.http.get<ApiResponse<ChartConfig[]>>(`${this.chartsBaseUrl}/getUserCharts`);
  }

  /**
   * Get all available charts for the current user
   * Endpoint: GET /agilelegal/charts/getavailablecharts
   * Uses the currently logged-in user from the session
   */
  getAvailableCharts(): Observable<ApiResponse<ChartConfig[]>> {
    return this.http.get<ApiResponse<ChartConfig[]>>(`${this.chartsBaseUrl}/getavailablecharts`);
  }

  /**
   * Map a chart to a user
   * Endpoint: POST /agilelegal/charts/mapchart/{chartId}/user/{userId}
   * @param userId The ID of the user
   * @param chartId The ID of the chart to map
   */
  mapChartToUser(userId: number, chartId: number): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(
      `${this.chartsBaseUrl}/mapchart/${chartId}/user/${userId}`,
      {} // Empty body as parameters are in the URL
    );
  }

  /**
   * Map multiple charts to a user (replaces all existing mappings)
   * Endpoint: POST /agilelegal/charts/mapcharts
   * @param userId The ID of the user
   * @param chartIds Array of chart IDs to map
   */
  mapChartsToUser(userId: number, chartIds: number[]): Observable<ApiResponse<any>> {
    const payload = {
      chartIds: chartIds,
      userId: userId
    };
    
    return this.http.post<ApiResponse<any>>(
      `${this.chartsBaseUrl}/mapcharts`,
      payload
    );
  }
}
